export default "__VITE_ASSET__BRQxYzOD__"